export default __webpack_public_path__ + "static/media/add_note_bookmark.e1e1fff0.png";